import { useQuery } from "@tanstack/react-query";
import { ShortCat } from "../models/shortCat";
import { CatsApi } from "../services";
import { Link } from "react-router-dom";
import { useState } from "react";

export const Cats = () => {
    const { data: catsData, isLoading, error } = useQuery<ShortCat[]>({
        queryKey: ["cats"],
        queryFn: CatsApi.getCats,
    });

    const [search, setSearch] = useState("");

    if (isLoading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>Error loading users</div>;
    }

    const cats = catsData ?? [];

    if (!cats) {
        return <div>404</div>
    }

    const filteredCats = cats?.filter(cat => {
        const filterName = cat?.name?.toLowerCase().includes(search.toLowerCase());
        const filterOwner = (cat?.owner?.name?.toLowerCase() + " " + cat?.owner?.surname?.toLowerCase()).includes(search.toLowerCase());
        return filterName || filterOwner;
    })

    return (
        <div>
            <div className="flex flex-col relative bg-[url('../public/cats/Mendeleev_Monoid_CZ.jpg')] bg-cover bg-center p-20 bg-fixed">
                <div className="absolute inset-0 bg-black opacity-65"></div>
                <div className="flex flex-col text-center">
                    <div className="text-white z-10 text-5xl">
                        Kočky
                    </div>
                </div>
            </div>

            <div className="flex flex-col space-y-5 md:w-2/3 mx-auto px-5 my-5">
                <input onChange={(e) => setSearch(e.target.value)} className="border border-black p-4 rounded" placeholder="Vyhledávač" />
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                    {
                        filteredCats.map((cat, key) => (
                            <CatItem cat={cat} key={key} />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

interface CatItemProps {
    cat: ShortCat
}

export const CatItem: React.FC<CatItemProps> = ({ cat }) => {
    return (
        <Link to={`/cats/${cat.catId}`} className="block hover:shadow-lg transition-shadow duration-300">
            <div className="flex bg-white shadow-md rounded-lg overflow-hidden">
                <div className="flex-shrink-0">
                    <img
                        src={cat.image}
                        alt="img"
                        className="w-32 h-32 object-cover"
                    />
                </div>
                <div className="flex-grow p-4">
                    <div className="text-2xl font-semibold text-gray-800">
                        {cat?.name}
                    </div>
                    <div className="text-lg text-gray-600">
                        {cat?.owner?.name} {cat?.owner?.surname}
                    </div>
                </div>
            </div>
        </Link>
    )
}